import { toDateOnly } from "@/domain/dates";
import type { InvoiceDisplayStatus, InvoiceListItem, InvoiceRecord } from "@/domain/types";

export function displayStatus(invoice: Pick<InvoiceListItem | InvoiceRecord, "status" | "dueDate">): InvoiceDisplayStatus {
  if (invoice.status === "paid" || invoice.status === "draft" || invoice.status === "void") return invoice.status;
  if (invoice.dueDate && invoice.dueDate < toDateOnly()) return "overdue";
  return "sent";
}
